module.exports = __webpack_public_path__ + "8bbafd5b0c9dfb8062b179b9692040c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2_2023_chart.png
// module id = 1685
// module chunks = 0